import { render, staticRenderFns } from "./KnowledgePointsList.vue?vue&type=template&id=1675e9c7&scoped=true"
import script from "./KnowledgePointsList.vue?vue&type=script&lang=js"
export * from "./KnowledgePointsList.vue?vue&type=script&lang=js"
import style0 from "./KnowledgePointsList.vue?vue&type=style&index=0&id=1675e9c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675e9c7",
  null
  
)

export default component.exports